import React, { FC } from 'react';
import ReactFacebookLogin from 'react-facebook-login';
import { useDispatch } from 'react-redux';
import { history } from '../../history';
import { loginWithFacebook } from '../../services/authentication/AuthenticationService';
import { setCurrent } from '../../slices/user';
import { removeOrganizationId, setKreezeeSession } from '../../utilities/LocalStorage';
import { FacebookIcon } from '../icons/FacebookIcon';
interface Props {
  setError: (e: string) => void;
}

const FacebookLogin: FC<Props> = ({ setError }: Props) => {
  const dispatch = useDispatch();

  async function handleLoginFacebook(response) {
    try {
      setError('');
      const accessToken = response.accessToken;
      const result = await loginWithFacebook(accessToken, 'fr');
      if (result.data) {
        removeOrganizationId();
        setKreezeeSession(JSON.stringify({ jwt: result.data.jwt }));
        dispatch(setCurrent({ ...result.data, jwt: null }));
        history.push('/');
      } else {
        setError('FacebookLogin: Error message');
      }
    } catch {
      setError('FacebookLogin: Error message');
    }
  }
  return (
    <ReactFacebookLogin
      appId={window.configs.facebookAppId}
      fields="name,email,picture"
      scope="public_profile,email"
      cssClass="facebook-login"
      containerClass="provider-button"
      icon={<FacebookIcon width={30} height={30} />}
      callback={handleLoginFacebook}
      textButton=""
    />
  );
};

export default FacebookLogin;
